<template>
    <FloatingPanel title="Initiatief uitgelicht">
        <div class="initiatief::canvas-blocks-modules-initiatief-uitgelicht-BlockPanel">
            <Tabs :tabs="['Maatwerk', 'Kleuren', 'Algemeen']">
                <div slot="Maatwerk">
                    <NumberInput
                        label="Initiatief ID"
                        instruction="Vul het ID in van het initiatief dat uitgelicht moet worden. Laat leeg (0) voor het meest recente goedgekeurde initiatief."
                        :options="options"
                        options-property="initiatief_id"
                        :min-val="0"
                        placeholder="0"
                        :open="true"
                        @valueChange="save()"
                    />
                </div>
                <div slot="Kleuren">
                    <ColorsInput
                        label="Icoon kleur"
                        instruction="Kleur van de iconen naast de gegevens."
                        :colors="colors"
                        :options="options"
                        options-property="iconColor"
                        :open="true"
                    />

                    <ColorsInput
                        label="Badge kleur"
                        instruction="Kleur van de status badge."
                        :colors="colors"
                        :options="options"
                        options-property="badgeColor"
                        :open="true"
                    />
                </div>
                <div slot="Algemeen">
                    <CommonInputs :options="options"/>
                </div>
            </Tabs>
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import NumberInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/NumberInput";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {
    extends: AbstractPanel,
    components: { FloatingPanel, CommonInputs, Tabs, NumberInput, ColorsInput },

    data() {
        return {
            colors: null,
        };
    },

    async mounted() {
        await this.loadColors();
    },

    methods: {
        async loadColors() {
            let databaseColors = (await getDatabaseColors(true)).data;

            this.colors = ['transparent', 'white', 'black'];

            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            });

            this.colors = _.uniq(this.colors);

            let formattedColors = {};
            for (const color of this.colors) {
                if (typeof color === 'object') {
                    for (const [key, value] of Object.entries(color)) {
                        formattedColors[key] = value;
                    }
                } else {
                    formattedColors[color] = color;
                }
            }

            this.colors = formattedColors;
        },
    },
}
</script>

<style lang="scss" scoped>
.initiatief\:\:canvas-blocks-modules-initiatief-uitgelicht-BlockPanel { }
</style>
